import { useMediaQuery } from "react-responsive";
import { ReactComponent as Doubletick } from "../../assets/svg/double-tick.svg";
import { ReactComponent as Checkcircle } from "../../assets/svg/check-circle.svg";
import { ReactComponent as Closecircle } from "../../assets/svg/close-circle-red.svg";
import { useState } from "react";
import { CandidateResult, JobQuestionCandidateAnswer } from "../../models/CandidateVacancyAnswerModel";

interface Props {
    questionsAndAnswers: JobQuestionCandidateAnswer[];
    candidateResult: CandidateResult;
    styles: any;
}

export const AnswersTab: React.FC<Props> = (props) => {
    const styles = props.styles;  
    const isMobile = useMediaQuery({ query: "(max-width: 786px)"}); 
    const [showFullAnswer, setShowFullAnswer] = useState(false);

    const handleShowFullAnswer = () => {
        setShowFullAnswer(!showFullAnswer);
    };

    return (
        <div style={styles.mainWrapper}>
            <div style={styles.rowWrapper}>
                <div style={styles.title}>Answers</div>
                {!isMobile && props.candidateResult && <div style={styles.screeningStatus}>
                    {props.candidateResult.result ? <Doubletick style={styles.screeningStatus.icon}/> : <Closecircle style={styles.screeningStatus.icon}/>}
                    <div style={styles.screeningStatus.text}>
                        {"Screening "}
                        {props.candidateResult.result ? <span style={styles.screeningStatus.bold}>{"Passed"}</span> : <span style={styles.screeningStatus.bold}>{"Failed"}</span>}
                    </div>
                </div>}
                {props.candidateResult && (
                    <>
                        <div style={styles.total}>{"Total"}</div>
                        <div style={styles.score}>{props.candidateResult.score + "%"}</div>
                    </>
                )}
            </div>
            {isMobile && props.candidateResult && <div style={styles.screeningStatus}>
                {props.candidateResult.result ? <Doubletick style={styles.screeningStatus.icon}/> : <Closecircle style={styles.screeningStatus.icon}/>}
                <div style={styles.screeningStatus.text}>
                    {"Screening "}
                    {props.candidateResult.result ? <span style={styles.screeningStatus.bold}>{"Passed"}</span> : <span style={styles.screeningStatus.bold}>{"Failed"}</span>}
                </div>
            </div>}
            <div style={styles.questionWrapper}>
                {props.questionsAndAnswers.length > 0 && props.questionsAndAnswers.map((qa, index) => (
                    <div key={qa.jobQuestion.jobQuestionId} style={styles.question}>
                        <div style={styles.questionNumber}>{"Question " + (index + 1).toString().padStart(2, '0')}</div>
                        <div style={styles.question.row}>
                            <div style={styles.question.text}>
                                {qa.jobQuestion.question}
                                {(qa.jobQuestion.questionTypeId === 6) && <span style={styles.question.knockout}>{"(knockout)"}</span>}
                            </div>
                            {(qa.jobQuestion.questionTypeId !== 5 && qa.jobQuestion.questionTypeId !== 6) && <div style={styles.question.score}>{qa.score}</div>}
                            {(qa.jobQuestion.questionTypeId === 6) && (
                                <div style={styles.question.score}>
                                    {qa.knockoutResult ? (<Checkcircle style={styles.question.icon}/>) : (<Closecircle style={styles.question.icon}/>)}
                                </div>
                            )}
                        </div>
                        <div style={styles.answerWrapper}>
                            <div style={styles.answerWrapper.text}>{"Answer"}</div>
                            <div style={styles.answerWrapper.answers}>
                                {qa.jobQuestion.questionTypeId === 2 ? (
                                    <ul style={styles.answerWrapper.list}>
                                        {qa.candidateAnswer.split(';').map((item, idx) => (
                                            <li key={idx}>{item.trim()}</li>
                                        ))}
                                    </ul>
                                ) 
                                : (
                                    <>
                                        {showFullAnswer
                                            ? qa.candidateAnswer
                                            : `${qa.candidateAnswer.substring(0, 180)}`
                                        }   
                                        {qa.candidateAnswer.length > 180 && (
                                            <span 
                                                onClick={() => handleShowFullAnswer()} 
                                                style={styles.answerWrapper.seeMore}
                                            >
                                                {showFullAnswer ? "See Less" : "See More"}
                                            </span>
                                        )}
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}
